export default __webpack_public_path__ + "static/media/temperatureIcon.b0ec94d0.svg";